import { render, staticRenderFns } from "./RescueOfEmergencyInChina.vue?vue&type=template&id=0261f0b4&scoped=true&"
import script from "./RescueOfEmergencyInChina.vue?vue&type=script&lang=js&"
export * from "./RescueOfEmergencyInChina.vue?vue&type=script&lang=js&"
import style0 from "./RescueOfEmergencyInChina.vue?vue&type=style&index=0&id=0261f0b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0261f0b4",
  null
  
)

export default component.exports